// extracted by mini-css-extract-plugin
export default {"company":"company_gNnJm"};